import React, { useEffect, useMemo, useState } from 'react';
import css from './styles.module.scss';
import { MusicListItemDto } from '~/models/music/music.dto';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { GridTable } from '~/features/dashboard/components/songs-list/components/gridTabel';
import { Search } from '~/common/search';
import { useSelector } from 'react-redux';
import { searchSongFilter } from '~/features/dashboard/store/selectors';
import { getSearchSongFilterActions } from '~/features/dashboard/store/actions';
import { Grid } from '@material-ui/core';
import { KeySongPage } from '~/models/music/new-song/helpers';
import { FilterSynch } from '~/common/filter-synch';

interface MusicsProps {
    songs: MusicListItemDto[];
    setFilters(filters: { search?: string; startDate?: string; endDate?: string }): void;
    page: number;
}

const getTableEntityFromMusic = (data: MusicListItemDto) => {
    const { songArtist, songName, writingShare, releaseDate, label, gSongReleaseYear, tags, assetCode } = data;

    return {
        artist: songArtist,
        title: songName,
        writingSharePercent: !writingShare || writingShare === 999 ? 'MISSING' : writingShare.toString() + '%',
        releaseDate,
        gSongReleaseYear,
        label,
        tags,
        assetCode,
        entity: data,
    };
};

export const SongsList: React.FC<MusicsProps> = ({ songs, page }) => {
    const data = useMemo(() => songs.map(song => getTableEntityFromMusic(song)), [songs]);
    const [searchValue, setSearchValue] = useState('');
    const multipleSelect = ['Genre', 'Context', 'Mood', 'Era'];
    const singleSelect = ['Classification', 'Behaviour'];

    const [filterTag, setFilterTag] = useState<any[]>([]);
    const [filter, setFilter] = useState<any[]>([]);

    const dispatch = useThunkDispatch();

    const getSearchDealValue = useSelector(searchSongFilter);

    useEffect(() => {
        filtered();
        // eslint-disable-next-line
    }, [filterTag, songs, searchValue, data]);

    const filtered = () => {
        const allFilters = filterTag.map(i => i.value).flat();
        const filteredTags =
            allFilters.length > 0
                ? data.filter(
                      item =>
                          allFilters
                              .map(it => {
                                  return (
                                      item.tags
                                          .map(i => i.value)
                                          .flat()
                                          .indexOf(it) !== -1
                                  );
                              })
                              .flat()
                              .indexOf(true) !== -1
                  )
                : data;
        const searchFilteredSongs = filteredTags.filter(
            item => item.title?.toLowerCase().includes(searchValue.toLowerCase()) || item.assetCode?.toLowerCase().includes(searchValue.toLowerCase())
        );

        setFilter(searchFilteredSongs);
    };

    const onChangeSearchFilter = (value: any) => {
        dispatch(getSearchSongFilterActions.success({ searchSongFilter: value }));
    };

    useEffect(() => {
        if (getSearchDealValue !== undefined) setSearchValue(getSearchDealValue);
    }, [getSearchDealValue]);

    const change = (value: any, type: string) => {
        let tags: any[] = filterTag || [];
        if (tags && tags.find((item: any) => item.type === type)) {
            tags.find((item: any) => item.type === type).value = value;
        } else {
            tags.push({
                type,
                value,
            });
        }
        setFilterTag(tags);
        filtered();
    };

    return (
        <div className={css.module}>
            <div className={css.filtersContainer}>
                <Grid container spacing={3} style={{ alignItems: 'flex-start' }}>
                    {page === KeySongPage.Synch &&
                        multipleSelect.map(item => (
                            <Grid item xs={3}>
                                <FilterSynch title={item} setFilter={value => change(value, item)} />
                            </Grid>
                        ))}
                    <Grid item xs={3}>
                        <div className={css.dateSearchContainer}>
                            <Search search={getSearchDealValue} onSearchChange={onChangeSearchFilter} className={css.search} />
                        </div>
                    </Grid>
                    {page === KeySongPage.Synch &&
                        singleSelect.map(item => (
                            <Grid item xs={3}>
                                <FilterSynch title={item} setFilter={value => change(value, item)} />
                            </Grid>
                        ))}
                </Grid>
            </div>
            <GridTable data={filter} pageTab={page} />
        </div>
    );
};
